module.exports = __webpack_public_path__ + "static/media/chocolate-chip-brownie.95047be4.png";